import { render, staticRenderFns } from "./AddCombo.vue?vue&type=template&id=4835a7aa&scoped=true&"
import script from "./AddCombo.vue?vue&type=script&lang=js&"
export * from "./AddCombo.vue?vue&type=script&lang=js&"
import style0 from "./AddCombo.vue?vue&type=style&index=0&id=4835a7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835a7aa",
  null
  
)

export default component.exports